import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { fetchMediaItem } from '../api/mediaApi';
import { placeholderSvgDataUrl } from '../utils/placeholderImage';

const MediaDetail = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      setErr('');
      try {
        const data = await fetchMediaItem(id);
        if (!mounted) return;
        setItem(data);
      } catch (e) {
        if (mounted) setErr(e?.message || 'Failed to load media');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [id]);

  if (!item) {
    return (
      <div className="container" style={{ padding: '4rem 0', textAlign: 'center' }}>
        <h1>{loading ? 'Loading...' : 'Media Not Found'}</h1>
        <p style={{ color: '#999' }}>{err || "The media item you're looking for doesn't exist."}</p>
        <Link to="/media" className="btn">
          Back to Media
        </Link>
      </div>
    );
  }

  const poster = item.thumbnail || placeholderSvgDataUrl({ width: 1200, height: 700, text: 'Video' });

  return (
    <div>
      <section>
        <div className="container" style={{ paddingTop: '3rem' }}>
          <div className="card" style={{ overflow: 'hidden' }}>
            {item.type === 'image' ? (
              <img src={item.file_url} alt={item.title} style={{ width: '100%', height: '520px', objectFit: 'contain' }} />
            ) : (
              <video
                src={item.file_url}
                controls
                style={{ width: '100%', maxHeight: 520, background: '#000' }}
                poster={poster}
              />
            )}
          </div>

          <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap' }}>
            <div style={{ color: '#999' }}>
              {item.category ? (
                <>
                  Category: <span style={{ color: 'var(--accent)' }}>{item.category}</span>
                </>
              ) : (
                ' '
              )}
            </div>
            <Link to="/media" className="btn-secondary">
              Back to Media
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MediaDetail;
